import React, {useEffect, useState} from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useNavigate, NavLink} from "react-router-dom";
import Grid from '@mui/material/Grid';
import { isMobile } from 'mobile-device-detect';
import HeaderDesktopMenu from "./HeaderDesktopMenu/HeaderDesktopMenu";
import HeaderMobileMenuButton from "./HeaderMobileMenuButton/HeaderMobileMenuButton";



const DesktopComponent: React.FC = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    return(
        <>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <Grid container spacing={{ xs: 2, md: 3 }}>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}  >
                                <Typography
                                    variant="h6"
                                    noWrap
                                    component={NavLink}
                                    color="secondary"
                                    to="/"
                                    sx={{ flexGrow: 1 }}
                                >
                                    DigitalBerd
                                </Typography>
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9} xl={9}
                                  style={{display: "flex", alignItems: "center"}}>
                                {isMobile ? <HeaderMobileMenuButton /> : <HeaderDesktopMenu />}
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    )
}

export default DesktopComponent;